// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LanguageSwitcher-wrapper-5Z_ttl79GE type-scaleZeta-34bbhATmUh"};